import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';

export interface TaskDataDialogProps {
  open: boolean;
  /** Null while nothing is being looked at. */
  data: Record<string, unknown> | null;
  onClose: () => void;
}

/**
 * The payload a scheduled task carries, as it is stored.
 *
 * Raw JSON on purpose: what is in here differs per scheduler and changes with
 * the code that writes it, so any rendering that named its fields would be out
 * of date before it was read.
 */
export function TaskDataDialog({ open, data, onClose }: TaskDataDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent size='lg'>
        <DialogHeader>
          <DialogTitle>Task Data</DialogTitle>
        </DialogHeader>

        <div className='max-h-96 overflow-auto px-5 py-4'>
          <pre className='rounded-md bg-fill-faint p-3.5 font-mono text-sm whitespace-pre-wrap text-ink-secondary'>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>

        <DialogFooter>
          <Button variant='quiet' onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
